/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';
import type { SAMLChallengeOptions } from './SAMLChallengeOptions';
import {
    SAMLChallengeOptionsFromJSON,
    SAMLChallengeOptionsFromJSONTyped,
    SAMLChallengeOptionsToJSON,
} from './SAMLChallengeOptions';

/**
 * 
 * @export
 * @interface SAMLChallenge
 */
export interface SAMLChallenge {
    /**
     * 
     * @type {string}
     * @memberof SAMLChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof SAMLChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof SAMLChallenge
     */
    authentication_method: FactorMethod;
    /**
     * 
     * @type {SAMLChallengeOptions}
     * @memberof SAMLChallenge
     */
    options: SAMLChallengeOptions;
}

/**
 * Check if a given object implements the SAMLChallenge interface.
 */
export function instanceOfSAMLChallenge(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;
    isInstance = isInstance && "options" in value;

    return isInstance;
}

export function SAMLChallengeFromJSON(json: any): SAMLChallenge {
    return SAMLChallengeFromJSONTyped(json, false);
}

export function SAMLChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAMLChallenge {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
        'options': SAMLChallengeOptionsFromJSON(json['options']),
    };
}

export function SAMLChallengeToJSON(value?: SAMLChallenge | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': ChallengeTypeToJSON(value.type),
        'authentication_method': FactorMethodToJSON(value.authentication_method),
        'options': SAMLChallengeOptionsToJSON(value.options),
    };
}

